var $eb1655a686c703e5$exports = {};
$eb1655a686c703e5$exports = {
    "maximum": `Maximum`,
    "minimum": `Minimum`
};


export {$eb1655a686c703e5$exports as default};
//# sourceMappingURL=fr-FR.module.js.map
